import React, { useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Visibility } from '@material-ui/icons';
import { parseISO, format } from 'date-fns';
import { isNull } from 'lodash';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/mensagemsistemaposto/actions';

import DetalheLog from '../components/DetalheLog';
import MyForm from './form';

function MensagemSistemaPosto() {
  const dispatch = useDispatch();
  const redux = useSelector((state) => state.mensagemsistemaposto);
  const buttons = [];
  const listaLogsRef = useRef(null);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  // Header tabela
  const header = useMemo(
    () => [
      {
        id: 'nomeabreviadoposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'aberturadatahoramensagemsistema',
        label: t('s.menu.cadastro.mensagem.aberturadatahoramensagemsistema'),
        formatted: (value) =>
          !isNull(value) ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
      },
      {
        id: 'fechamentodatahoramensagemsistema',
        label: t('s.menu.cadastro.mensagem.fechamentodatahoramensagemsistema'),
        formatted: (value) =>
          !isNull(value) ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
      },
      {
        id: 'datainiciexibicaomensagemsistema',
        label: t('s.menu.cadastro.mensagem.datainiciexibicaomensagemsistema'),
        formatted: (value) =>
          !isNull(value) ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
      },
      {
        id: 'datafimexibicaomensagemsistema',
        label: t('s.menu.cadastro.mensagem.datafimexibicaomensagemsistema'),
        formatted: (value) =>
          !isNull(value) ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
      },
      {
        id: 'numeroexibioesmensagemsistema',
        label: t('s.menu.cadastro.mensagem.numeroexibioesmensagemsistema'),
        filter: { type: 'text' },
      },
      {
        id: 'msg01mensagemsistema',
        label: t('s.menu.cadastro.mensagem.msg01mensagemsistema'),
        filter: { type: 'text' },
      },
      {
        id: 'msg02mensagemsistema',
        label: t('s.menu.cadastro.mensagem.msg02mensagemsistema'),
        filter: { type: 'text' },
      },
      {
        id: 'msg03mensagemsistema',
        label: t('s.menu.cadastro.mensagem.msg03mensagemsistema'),
        filter: { type: 'text' },
      },
      {
        id: 'msg04mensagemsistema',
        label: t('s.menu.cadastro.mensagem.msg04mensagemsistema'),
        filter: { type: 'text' },
      },
      {
        id: 'statusmensagemsistema',
        label: t('s.menu.cadastro.mensagem.statusmensagemsistema'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status, defaultValue: 'L' },
      },
    ],
    [status]
  );

  const headerbuttons = useMemo(
    () => [
      buttons.push({
        title: 'Detalhe',
        action: (value) => listaLogsRef.current.handleToggleModal(value),
        icon: <Visibility />,
      }),
    ],
    [redux]
  );

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(redux.paramss));
  }, [redux.params]);

  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={recordFiltering}
        find={findData}
        remove={deleteData}
        form={MyForm}
        keys="idmensagemsistema"
        detach="idmensagemsistema"
        actions={buttons}
      />

      <DetalheLog
        ref={listaLogsRef}
        update={() => handleUpdate()}
        name="detalhe"
      />
    </>
  );
}

export default MensagemSistemaPosto;
